import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useInView } from 'react-intersection-observer';
import {
	GAClickProduct,
	GAImpressions,
	getConfiguratorPosition,
	TGAImpressions,
} from 'utils/analytics';
import { TConfigurator } from '../../../types';
import { selectConfigurators } from '../../../selectors';

export const useAnalytics = (configurator: TConfigurator) => {
	const configuratorsList = useSelector(selectConfigurators);
	const { id, name, price } = configurator;
	const cardPosition = getConfiguratorPosition(configuratorsList, id);

	const productData = {
		productId: id.toString(),
		productName: name,
		productPrice: price?.toString() || '0',
		productPosition: cardPosition,
	};

	const eventData: TGAImpressions = {
		elementBlock: 'serviceList',
		...productData,
	};

	const analyticsClickHandler = (e: React.MouseEvent<HTMLElement>) => {
		const element = e.target as HTMLElement;
		const elementName =
			element.closest('[data-analyticsname]')?.getAttribute('data-analyticsname') ||
			'productBlockLink';
		GAClickProduct({
			elementName,
			...eventData,
		});
	};

	// scroll analytics
	const { ref, inView } = useInView();

	useEffect(() => {
		if (inView) {
			GAImpressions(eventData);
		}
	}, [inView]);

	return {
		ref,
		analyticsClickHandler,
	};
};
